























































import { Component, Vue, Prop } from 'vue-property-decorator'

import { User } from '../../../store/user/types'
import FeatureType from '../../../lib/masters/FeatureType'
import Feature from '../../../lib/masters/Feature'
import SpecialtyType from '../../../lib/masters/SpecialtyType'
import Specialty from '../../../lib/masters/Specialty'

@Component
export default class UserCard extends Vue {
  @Prop() user!: User
  active = false

  get fullName() {
    return `${this.user.familyName} ${this.user.firstName}`
  }

  toSpecialtyText(type: SpecialtyType) {
    return Specialty[type].text
  }

  toSpecialtyColor(type: SpecialtyType) {
    return type === SpecialtyType.Insurance
      ? 'green'
      : type === SpecialtyType.RealEstate
      ? 'pink'
      : 'cyan'
  }

  toFeatureText(type: FeatureType) {
    return Feature[type].text
  }

  handleClick() {
    this.$emit('click')
  }
}
